module.exports = __webpack_public_path__ + "img/monkey.339efcf6.png";